<template>
  <div
    ref="mapContinent"
    class="map-continent"
    :class="{ 'map-continent--active': currentRegion === region.code }"
    :style="{ 
      left: region.leftMVw + 'px', 
      top: region.topMVw + 'px',
      transform: `scale(${scale }) translate(-50%, -50%)`
    }"
    @click="$emit('click:title', region)"
  >
    <div
      v-if="region.items && computedItems.length"
      class="map-continent__counter"
    >
      <a
        class="map-continent__counter-anchor"
      >
        {{ computedItems.length }}
      </a>
    </div>
    <div
      class="map-continent__name"
      :style="{ 
        'max-width': region.maxNameWidth ? `${region.maxNameWidth}px` : 'none',
      }"
    >
      <a
        class="map-continent__name-anchor"
      >
        {{ region.name }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapContinent',
  props: {
    currentScale: {
      type: Number,
      required: true,
    },
    currentRegion: {
      type: String,
      required: true,
    },
    contentRatio: {
      type: Number,
      required: true,
    },
    region: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: String,
      required: true,
    },
    vertical: {
      type: String,
      required: true,
    },
    productCategory: {
      type: String,
      required: true,
    },
  },
  data() {
    return  {
      translateTop: 0,
      translateLeft: 0,
    }
  },
  computed: {
    computedItems() {
      return this.region.items.filter((item) => {
        if ((this.viewMode === 'region') || (this.viewMode === 'vertical' && item.vertical === this.vertical)) {
          return item
        }
        else if (this.viewMode === 'product') {
          let hasFilterCategory = false
          item.recommendedProduct.forEach(product => {
            if (product.productCategory1 === this.productCategory) {
              hasFilterCategory = true
            }
          })
          if (hasFilterCategory) {
            return item
          }
        }
      });
    },
    scale() {
      return  (1 / this.currentScale) / (1 * this.contentRatio)
    }
  },
  mounted() {
    this.translateTop = (this.$refs.mapContinent.clientHeight / 2) * -1
    this.translateLeft = (this.$refs.mapContinent.clientWidth / 2) * -1
  },
}
</script>

<style lang="scss" scoped>
@import '~@/scss/function.scss';

$map-continent: '.map-continent';
#{$map-continent} {
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: 0% 0%;
  text-align: center;

  &__counter {
    width: calc(42px * 0.7);
    height: calc(42px * 0.7);
    line-height: calc(46px * 0.7);
    margin: 0 auto calc(10px * 0.7);
    background-color: #6e6e6e;
    text-align: center;
    border-radius: 100%;
    font-size: 15px;
    box-shadow: 0px 2px 3.84px 0.16px rgba(0, 0, 0, 0.35);
  }
  &__counter-anchor {
    color: #fff;
  }
  &__name {
    font-size: calc(24px * 0.7);
    width: calc(118px * 0.7);
    line-height: 120%;
  }
  &__name-anchor {
    color: #333;
    font-weight: 400;
  }
  &__name-anchor:hover {
    cursor: pointer;
  }
  &__name-anchor:hover {
    color: #fd312e;
  }
  &--active {
    #{$map-continent} {
      &__counter {
        background-color: #fd312e;
      }
      &__name-anchor {
        color: #fd312e;
      }
    }
  }
}


</style>
